var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSms = function SvgSms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.52949 10.1517L1.55949 12.485V2.15165C1.55949 1.97484 1.62972 1.80527 1.75475 1.68025C1.87977 1.55522 2.04934 1.48499 2.22615 1.48499H12.2262C12.403 1.48499 12.5725 1.55522 12.6976 1.68025C12.8226 1.80527 12.8928 1.97484 12.8928 2.15165V10.1517H4.52949ZM4.06815 8.81832H11.5595V2.81832H2.89282V9.74165L4.06815 8.81832ZM6.22615 11.485H13.0508L14.2262 12.4083V5.48499H14.8928C15.0696 5.48499 15.2392 5.55522 15.3642 5.68025C15.4892 5.80527 15.5595 5.97484 15.5595 6.15165V15.1517L12.5895 12.8183H6.89282C6.71601 12.8183 6.54644 12.7481 6.42142 12.6231C6.29639 12.498 6.22615 12.3285 6.22615 12.1517V11.485Z"
  })));
};
export default SvgSms;